// src/components/DebugPanel.js
import React, { useState } from "react";
import {
  Box,
  Button,
  Chip,
  Collapse,
  Paper,
  Stack,
  Typography,
} from "@mui/material";

export default function DebugPanel({
  apiBase,
  sessionId,
  health,
  onFillDummyValues,
  onFillDummyValuesCertification,
  futureSelection,
  shortlistPreview,
  showRawStep5,
  setShowRawStep5,
  marginBottom
}) {
  const [open, setOpen] = useState(false);

  const hasStep5Data =
    !!futureSelection ||
    (Array.isArray(shortlistPreview) && shortlistPreview.length > 0);

  return (
    <Box marginBottom={marginBottom} >
      <Button
        size="small"
        variant="outlined"
        onClick={() => setOpen((prev) => !prev)}
      >
        {open ? "Hide debug menu" : "Show debug menu"}
      </Button>

      <Collapse in={open} timeout="auto" unmountOnExit>
        <Paper
          variant="outlined"
          sx={{ p: 2, mt: 1, borderRadius: 2, bgcolor: "grey.50" }}
        >
          <Typography variant="subtitle2" gutterBottom>
            Debug information
          </Typography>

          {/* API / Session / Catalog chips */}
          <Box sx={{ display: 'flex', alignItems: 'center', flexWrap: 'wrap', gap: 1, mb: 2 }}>
            <Chip label={`API: ${apiBase}`} sx={{ maxWidth: "100%" }} />
            <Chip
              color="primary"
              label={sessionId ? `Session: ${sessionId}` : "Creating session…"}
              sx={{ maxWidth: "100%" }}
            />
            {health && <Chip label={`Catalog: ${health.mlus_loaded} MLUs`} sx={{ maxWidth: "100%" }} />}
          </Box>

          {/* Debug actions */}
          <Stack direction="row" spacing={1} sx={{ mb: 2 }}>
            <Button
              size="small"
              variant="contained"
              onClick={onFillDummyValues}
              disabled={!sessionId}
            >
              Fill standard values
            </Button>
            <Button
              size="small"
              variant="contained"
              color="secondary"
              onClick={onFillDummyValuesCertification}
              disabled={!sessionId}
            >
              Fill cert values
            </Button>
          </Stack>

          {/* Step 5 raw JSON */}
          {hasStep5Data && (
            <Box sx={{ mt: 1 }}>
              <Typography variant="caption" color="text.secondary">
                Step 5 raw JSON (backend response)
              </Typography>
              <Box sx={{ mt: 1 }}>
                <Button
                  size="small"
                  variant="text"
                  onClick={() => setShowRawStep5((s) => !s)}
                >
                  {showRawStep5 ? "Hide raw JSON" : "Show raw JSON"}
                </Button>
                {showRawStep5 && (
                  <Paper
                    variant="outlined"
                    sx={{ p: 2, mt: 1, maxHeight: 300, overflow: "auto" }}
                  >
                    <pre
                      style={{ whiteSpace: "pre-wrap", wordBreak: "break-word" }}
                    >
                      {JSON.stringify(
                        {
                          future: futureSelection,
                          shortlist_preview: shortlistPreview,
                        },
                        null,
                        2
                      )}
                    </pre>
                  </Paper>
                )}
              </Box>
            </Box>
          )}
        </Paper>
      </Collapse>
    </Box>
  );
}
